// Worker-event threads (#4005): one thread per worker per event, organized by
// the server into sub-threads named from where each conversation started.

import { useQuery } from '@tanstack/react-query';

import { getChatTopics, getEventThreads, previewChatTopic } from './api';
import { chatKeys } from './keys';

import type { RecordSourceType } from 'src/models/chat';

export function useEventThreads(filter: { eventId?: number; workerId?: number } = {}, enabled = true) {
  return useQuery(chatKeys.eventThreads(filter), () => getEventThreads(filter), { enabled, staleTime: 15_000 });
}

export function useChatTopics(chatId: number | undefined, enabled = true) {
  return useQuery(chatKeys.chatTopics(chatId ?? 0), () => getChatTopics(chatId as number), {
    enabled: enabled && typeof chatId === 'number' && chatId > 0,
  });
}

export function useTopicPreview(chatId: number | undefined, source?: { type: RecordSourceType; id?: number } | null) {
  return useQuery(
    chatKeys.topicPreview(chatId ?? 0, source?.type ?? '', source?.id),
    () => previewChatTopic(chatId as number, source!.type, source?.id),
    { enabled: typeof chatId === 'number' && chatId > 0 && !!source, staleTime: 60_000 }
  );
}
